import { useState, useEffect } from "react";

// Definindo o tipo do parâmetro do hook
function useConvertStringToDate(
  dataString: string | null | undefined
): Date | null {
  const [convertedDate, setConvertedDate] = useState<Date | null>(null);

  useEffect(() => {
    // Se dataString for null ou undefined, não faça nada
    if (!dataString) {
      setConvertedDate(null);
      return; // Sair cedo se não há string de entrada válida
    }

    const partes = dataString.split(" ");
    const dataPartes = partes[0].split("/");
    const horaPartes = partes[1]?.split(":") || ["00", "00", "00"];

    const ano = parseInt(dataPartes[2], 10);
    const mes = parseInt(dataPartes[1], 10) - 1; // Mês (convertido para índice base-0)
    const dia = parseInt(dataPartes[0], 10);
    const hora = parseInt(horaPartes[0], 10);
    const minuto = parseInt(horaPartes[1], 10);
    const segundo = parseInt(horaPartes[2], 10);

    // Criar objeto Date preservando a data original sem ajustes de fuso horário
    const dataConvertida = new Date(ano, mes, dia, hora, minuto, segundo);
    setConvertedDate(dataConvertida);
  }, [dataString]);

  return convertedDate;
}

export default useConvertStringToDate;
